module.exports = "data:application/octet-stream;base64,QGltcG9ydCAnLi4vLi4vc3R5bGVzL3ZhcmlhYmxlcy5zY3NzJzsNCg0KLmdjbC1kbmQgew0KCWRpc3BsYXk6IGJsb2NrOw0KCXBhZGRpbmc6IDA7DQoJbWFyZ2luOiAwOw0KCSYucmVsYXRpdmUgew0KCQlwb3NpdGlvbjogcmVsYXRpdmU7DQoJfQ0KCSYuYWJzb2x1dGUgew0KCQlwb3NpdGlvbjogYWJzb2x1dGU7DQoJfQ0KCWlucHV0IHsNCgkJZGlzcGxheTogbm9uZTsNCgl9DQp9DQo="


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/DragNDropWrapper/DragNDropWrapper.scss
// module id = 2546
// module chunks = 0